import { render, staticRenderFns } from "./AnnouncementDescription.vue?vue&type=template&id=ba5a27d0&scoped=true"
import script from "./AnnouncementDescription.vue?vue&type=script&lang=js"
export * from "./AnnouncementDescription.vue?vue&type=script&lang=js"
import style0 from "./AnnouncementDescription.vue?vue&type=style&index=0&id=ba5a27d0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba5a27d0",
  null
  
)

export default component.exports